<!-- eslint-disable max-len -->
<template>
    <div
        class="mobile-general-form-upload mobile-general-form-id-upload"
        :class="`uuid-${config.uuid}  ${!!props.required && !globalModel.preview ? 'is-required' : ''} ${globalModel.preview ? 'preview-text' : ''} ${ocrStatus ? 'has-ocr-result' : ''} ${notChanged ? 'disable-opacity' : ''}`"
        v-show="!props.hide"
        ref="uploadRef"
    >
        <form-group :title="i18nLabel" :class="{ 'hide-title': !!props.hideTitle } ">
            <sub-title class="mt4" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
            <sub-title :text="props.subTitle" :errorMsg="errorMsg"></sub-title>
            <div class="content-wrapper">
                <div
                    v-show="showFrontPreview"
                    :style="{backgroundImage: `url(${props.frontSrc})`}"
                    class="previewer-img"
                    @click="onAddButtonClick(0)"
                >
                    <div class="dark-mask"></div>
                    <div class="info">
                        <div class="icon-id-upload"></div>
                        <div class="tips">
                            {{ props.frontHint }}
                        </div>
                    </div>
                </div>
                <upload-item
                    v-if="!showFrontPreview"
                    v-model="fileList[0]"
                    :key="fileList[0].fileId"
                    @upload-success="onUploadSuccess"
                    @upload-preview="onPreviewClick(0)"
                    @retry-select="onAddButtonClick(0)"
                    @upload-clear="onUploadClear(0)"
                ></upload-item>
                <div class="divider"></div>
                <div
                    v-show="showBackPreview"
                    :style="{backgroundImage: `url(${props.backSrc})`}"
                    class="previewer-img"
                    @click="onAddButtonClick(1)"
                >
                    <div class="dark-mask"></div>
                    <div class="info">
                        <div class="icon-id-upload"></div>
                        <div class="tips">
                            {{ props.backHint }}
                        </div>
                    </div>
                </div>
                <upload-item
                    v-if="!showBackPreview"
                    v-model="fileList[1]"
                    :key="fileList[1].fileId"
                    @upload-success="onUploadSuccess"
                    @upload-preview="onPreviewClick(1)"
                    @retry-select="onAddButtonClick(1)"
                    @upload-clear="onUploadClear(1)"
                ></upload-item>
            </div>

            <div v-if="showErrorMsg" class="sp-form-item__error">
                {{ errorMsg }}
            </div>
            <ocr-result :ocrStatus="ocrStatus" :desc="ocrDesc"></ocr-result>
        </form-group>
        <input
            class="mobile-general-form-upload__input"
            type="file"
            ref="input"
            :accept="props.accept"
            @change="onInputChange"
        />
        <img-previewer
            ref="imgPreviewerRef"
            :previewList="previewList"
            @on-delete-file="onUploadClear"
            :noticeFormPreview="globalModel.noticeFormPreview"
        ></img-previewer>
    </div>
</template>
<script>
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import FormGroup from '@ks/sharp-comp-form-group';
import '@ks/sharp-comp-form-group/lib/themes/default/index.css';
import '@ks/sharp-comp-image-upload/lib/themes/default/index.css';
import ComponentBase from '../component-base';
import { component } from './props';
import { base64ToFile } from '../../utils/file';
import UploadItem from '../mobile-general-form-upload/upload-item.vue';
import { FILE_STATUS } from './config';
import { OCR_STATUS, URL_IMG_OCR } from '../../const';
import { composeUrlWithParam } from '../../utils';
import '@ks/sharp-comp-previewer/lib/themes/default/index.css';
import ImgPreviewer from '../component-base/common/img-previewer';
import SubTitle from '../component-base/common/sub-title';
import OcrResult from '../component-base/common/ocr-result.vue';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
import { $fileUploader } from '../component-base/xhr';
import { canBridgeUse, useBridge } from '../../utils/bridge/common';

export default {
    name: component,
    components: {
        UploadItem,
        FormGroup,
        SubTitle,
        ImgPreviewer,
        OcrResult,
    },
    extends: ComponentBase,
    provide() {
        return {
            uploadComponent: this, // 给内层组件提供一个使用最外层的入口
        };
    },
    data() {
        return {
            // 组件内部维护一份文件列表
            fileList: [undefined, undefined],
            // 验证错误信息
            errorMsg: '',
            // 生成fileId使用
            tempIndex: 1,
            // 预览图
            showPreview: false,
            previewImgSrc: '',
            imgWidth: '90px',
            previewList: [],
            curPreviewIndex: 0,
            showErrorMsg: false,
            curIndex: -1,
            isFirst: true, // props.hide首次变化
            ocrStatus: OCR_STATUS.INIT, // 0是初始态
        };
    },
    computed: {
        showFrontPreview() {
            return !(this.fileList[0] && this.fileList[0].value);
        },
        showBackPreview() {
            return !(this.fileList[1] && this.fileList[1].value);
        },
        fileValue() {
            return this.fileList.map(item => {
                return item ? item.value : '';
            });
        },
        allSuccess() {
            if (this.fileList[0] === undefined && this.fileList[1] === undefined) {return true;}
            if (this.fileList.length) {
                return this.fileList.every(item => item && item.status === FILE_STATUS.success);
            }
            return true;
        },
        isProgressing() {
            if (this.fileList[0] === undefined && this.fileList[1] === undefined) {return false;}
            if (this.fileList.length) {
                return !!this.fileList.find(item => item && item.status === FILE_STATUS.progress);
            }
            return false;
        },
        ocrDesc() {
            let desc = '';
            switch (this.ocrStatus) {
                case OCR_STATUS.FAIL:
                    desc = this.props.ocrFail || '识别失败！请按照提示填写以下内容';
                    break;
                case OCR_STATUS.SUCCESS:
                    desc = this.props.ocrSuccess || '识别成功！请确保识别内容是否与图片信息一致';
                    break;
            }
            return desc || '';
        },
        extraParams() {
            return this.globalModel.globalParams || {
                ...this.$route.params,
                ...this.$route.query,
            };
        },
        logParams() {
            return {
                is_ocr: this.props.isOcr ? 1 : 0,
                item_title: this.i18nLabel,
                item_id: this.props.ocrType || -1,
            };
        },
    },
    watch: {
        allSuccess(val) {
            if (val) {
                // console.log('all-success');
                this.$emit('all-success');
                this.updateSelfValue();
            }
        },
        async fileValue(newVal) {
            this.previewList = await this.getPreviewList(newVal);
        },
        'props.hide': {
            handler(val) {
                // 只执行一次 避免重复计算
                if (!val && this.isFirst) {
                    this.updateImgWidth();
                    this.isFirst = false;
                }
            },
        },
    },
    async mounted() {
        this.updateImgWidth();
        !this.globalModel.preview && formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'IDENTITY_CARD_UPLOAD', this.logParams);
    },
    methods: {
        onDeleteFile(index) {
            this.fileList.splice(index, 1);
            this.updateSelfValue();
        },
        async getPreviewList(fileList) {
            const params = this.globalModel.globalParams ? {
                ...this.globalModel.globalParams,
                from: this.$route.query.from || this.$route.params.from || '',
            } : {
                ...this.$route.params,
                ...this.$route.query,
            };
            const allReq = fileList.filter(item => !!item).map(item => {
                return new Promise(resolve => {
                    const src = composeUrlWithParam(this.props.previewSrc + '&from={from}&type={type}', {
                        ...params,
                        ...this.globalModel.formData,
                        file: item,
                        type: this.globalModel.viewType || 0,
                    });
                    const image = new Image();
                    image.onload = () => {
                        resolve({
                            src,
                            w: image.width,
                            h: image.height,
                        });
                    };
                    image.onerror = () => {
                        resolve({
                            src,
                            w: 1080,
                            h: 1080,
                        });
                    };
                    image.src = src;
                });
            });
            const res = await Promise.all(allReq);
            return res;
        },
        onPreviewClick(index) {
            if (!this.onClickForm()) {return;}
            let showIndex = index;
            if (index >= this.previewList.length) {
                showIndex = this.previewList.length - 1;
            }
            this.$refs.imgPreviewerRef.showIndex(showIndex);
        },
        onUploadSuccess() {
            this.updateSelfValue();
        },
        onUploadClear(index) {
            if (index > -1) {
                this.$set(this.fileList, index, undefined);
                this.updateSelfValue();
            }
        },
        async onOcrIdentify(files) {
            const { bizKey = '', from = '' } = this.extraParams;
            // 如果没选ocrType、 bizKey 直接return
            if (!this.props.ocrType || !bizKey) {
                return;
            }
            const url = URL_IMG_OCR.replace('{bizKey}', bizKey);
            const payload = new FormData();
            // 将FileList对象转换为数组
            const fileListArray = Array.from(files);
            fileListArray.forEach(file => {
                payload.append('files', file);
            });
            payload.append('from', from);
            payload.append('type', this.props.ocrType);
            const { data } = await $fileUploader.post(
                url,
                payload
            );
            // 1. 判断result更新识别结果  2. 把识别结果的值传递下去
            this.ocrStatus = data.result === 1 ? OCR_STATUS.SUCCESS : OCR_STATUS.FAIL;
            formEventBus.$emit(FORM_EVENTS_TYPE.OCR_RECOGNITION, { listen: this.config.uuid, ocrResult: { ...data.data } });
        },
        async onAddButtonClick(index) {
            if (this.globalModel.preview) {
                return;
            }
            if (!this.notChanged) {
                this.curIndex = index;
                // 上报点击
                this.logger('upload-click');
                formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CLICK', 'IDENTITY_CARD_UPLOAD', this.logParams);
                const isSelectImageSupport = await canBridgeUse('post.selectImage')
                    && this.props.accept.includes('image') && !this.props.accept.includes('video');
                if (!isSelectImageSupport) {
                    this.$refs.input.value = null;
                    this.$refs.input.click();
                    return;
                }
                const bridgeParams = {
                    count: 1,
                    // 可以指定来源是相册还是相机，默认二者都有
                    sourceType: ['album', 'camera'],
                    // 字节单位，不存在则为不限制，原图超过该值时自动压缩
                    maxFileSize: this.props.maxSize ? this.props.maxSize * 1024 : 20 * 1024 * 1024,
                    // 像素单位，不存在则为不限制，原图超过该值时自动压缩，建议设置，否则图太大
                    maxWidth: 8640,
                    // 像素单位，不存在则为不限制，原图超过该值时自动压缩，建议设置，否则图太大
                    maxHeight: 8640,
                    // success: ret => {
                    //     setTimeout(() => {
                    //         ret.data.forEach(item => {
                    //             const file = base64ToFile(item);
                    //             this.onFileSelect([file]);
                    //         });
                    //     }, 0);
                    // },
                    // fail: err => {
                    //     setTimeout(() => {
                    //         console.log('fail:' + JSON.stringify(err));
                    //     }, 0);
                    // },
                };
                const nameSpaceApi = 'post.selectImage';
                await useBridge(nameSpaceApi, bridgeParams, res => {
                    setTimeout(() => {
                        if (res.result === 1) {
                            res.data.forEach(item => {
                                const file = base64ToFile(item);
                                this.onFileSelect([file]);
                            });
                        } else {
                            console.log('fail:' + JSON.stringify(res));
                        }
                    }, 0);
                });
            }
        },
        onInputChange(ev) {
            const files = ev.target.files;
            if (!files) {return;}
            this.onFileSelect(files);
        },
        onFileSelect(files) {
            if (this.props.max && this.fileList.length + files.length > +this.props.max) {
                this.validateFailureHandler(this.i18n(this.props.errMax, this.i18nLabel, this.props.max)
                    || `${this.i18nLabel}不得大于${this.props.max}项`);
                return;
            }
            this.$set(this.fileList, this.curIndex, {
                fileId: Date.now() + this.curIndex,
                status: this.props.autoUpload ? FILE_STATUS.ready : FILE_STATUS.success,
                value: files[0],
            });
            this.props.isOcr && this.onOcrIdentify(files);
        },
        updateSelfValue() {
            this.setSelfFormDataValue(cloneDeep(this.fileValue)) && this.$emit('change');
            // this.validateSelf();
        },
        // 判断是否满足自身条件
        validateSelf() {
            if (!this.allSuccess) {
                this.errorMsg = this.i18n(this.props.errUpload, this.i18nLabel) || `请检查${this.i18nLabel}`;
                return false;
            }
            if (this.props.required && (!this.fileValue[0] || !this.fileValue[1])) {
                this.errorMsg = this.i18n(this.props.errRequired, this.i18nLabel) || `必须上传${this.i18nLabel}`;
                return false;
            }
            this.errorMsg = '';
            return true;
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            if (!this.allSuccess) {
                // 如果还有文件不处于成功态则跳过处理，否则某些处理中的文件可能被丢弃
                return;
            }
            const newValue = this.getSelfFormDataValue();
            if (!Array.isArray(newValue)) {
                // 需要初始化，默认值空数组
                this.fileList = [];
                this.setSelfFormDataValue(this.fileValue);
                return;
            }

            if (!isEqual(this.fileValue, newValue)) {
                let changed = false;
                for (const itemIndex in newValue) {
                    if (!this.fileList[itemIndex]) {
                        changed = true;
                        this.$set(this.fileList, itemIndex, {
                            // 模仿elementUI 上传组件给每个文件添加id
                            fileId: Date.now() + this.tempIndex++,
                            // 被动修改默认是已经上传好的
                            status: FILE_STATUS.success,
                            value: cloneDeep(newValue[itemIndex]),
                        });
                        // this.fileList.push();
                    } else if (
                        typeof this.fileList[itemIndex].value === 'string'
                        && typeof newValue[itemIndex] === 'string'
                        && this.fileList[itemIndex].value !== typeof newValue[itemIndex]) {
                        changed = true;
                        // 只有自身数据和全局数据同时为字符串类型且不相等时才允许修改
                        this.fileList[itemIndex].status = FILE_STATUS.success;
                        this.fileList[itemIndex].value = newValue[itemIndex];
                    }
                }
                // 长度统一
                while (this.fileList.length > newValue.length) {
                    changed = true;
                    this.fileList.pop();
                }

                // 数据被动修改同样抛出change事件
                changed && this.$emit('change');
                // this.validateSelf();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const res = this.validateSelf();
            this.showErrorMsg = !res;
            if (!res) {
                this.validateFailureHandler(this.errorMsg);
            }
            return res;
        },
        clearValidate() {
            this.errorMsg = '';
            this.showErrorMsg = false;
        },
        async updateImgWidth() {
            await this.$nextTick();
            await new Promise(resolve => setTimeout(resolve, 100));
            try {
                const el = this.$refs.uploadRef.querySelector('.spc-image-upload');
                let clientWidth = el.clientWidth || 90;
                if (clientWidth < 50) {
                    clientWidth = 90;
                }
                this.imgWidth = `${clientWidth || 90}px`;
            } catch (error) {
                //
            }
        },
    },

};
</script>
<style lang="less" scoped>
@import '../../style.less';
.is-required {
    /deep/ .spc-form-group h2:after {
        content: '*';
        color: #ff4a4a;
        font-size: inherit;
        line-height: inherit;
    }
}

.mobile-general-form-id-upload {
    .content-wrapper {
        display: flex;
        flex-direction: row;
        margin-top: 12px;
        /deep/ .spc-image-upload {
            flex: 1;
            height: 116px;
            border-radius: 8px;
        }
        .divider {
            width: 8px;
            height: 100%;
        }
        .previewer-img {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
            height: 116px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            border-radius: 8px;
            position: relative;
            .dark-mask {
                display: none;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background-color: #000000;
                opacity: 0.7;
                border-radius: 8px;
                z-index: 1;
            }
            .info {
                z-index: 2;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                .icon-id-upload {
                    width: 26px;
                    height: 26px;
                    margin-bottom: 5px;
                    background-image: url('../../../assets/images/camera.svg');
                }
                .tips {
                    color: #FFF;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                }
            }
            // &:first-of-type {
            //     margin-right: 8px;
            // }
        }
    }
    /deep/ .sp-form-item__error {
        display: none !important;
    }

    & > input {
        display: none;
    }
    .counter-text {
        position: absolute;
        right: 16px;
        top: 16px;
        color: #9c9c9c;
        font-size: 15px;
        font-weight: 400;
    }

    /deep/ .spc-form-group {
        position: relative;
        .content {
            // display: flex;
            // flex-flow: row wrap;
            position: relative;
            margin: 0 16px;
        }
        & > h2 {
            margin: 0 16px 0 16px !important;
            padding: 0 0 !important;
            font-size: 15px;
            line-height: 23px;
        }
    }

    .spc-image-upload {
        // width: calc(25% - 6px);
        // padding-bottom: 16px;
        // aspect-ratio: 1 / 1;
        margin-left: 0 !important;
        /deep/ .box {
            width: 100%;
            height: auto!important;
            .add {
                margin-bottom: 1px;
                width: 24px;
                height: 24px;
                background: var(--csc-collect-spc-image-upload-add) no-repeat 50%;
                background-size: 100% 100%;
            }
            .tip {
                margin-top: 1px;
                line-height: 17px;
                padding: 0 8px;
            }
        }
    }
}
.has-ocr-result {
    /deep/ .spc-form-group {
        padding-bottom: 0 !important;
        margin-bottom: -6px;
    }
    /deep/ .content {
        overflow-y: hidden;
    }
}
</style>
